import { CHALLENGE_TEST, PRACTICE_TEST, DAILY_TEST, PLANNED_TEST, ADMIN_TEST, FOR_CHALLENGE_TEST } from './../../store/constants';
import moment from 'moment';

export const isPracticeTest = testType => testType === PRACTICE_TEST;
export const isChallengeTest = testType => testType === CHALLENGE_TEST;
export const isDailyTest = testType => testType === DAILY_TEST; 
export const isPlannedTest = testType => testType === PLANNED_TEST;
export const isAdminTest = testType => testType === ADMIN_TEST;

export const isAdminCreatedTest = test => test.user_rank === 0;
export const isAdminFreeTest = test => isAdminCreatedTest(test) && test.bid_amount === 0;
export const isAcceptedAdminFreeTest = test => isAdminFreeTest(test) && test.pivot && Object.keys(test.pivot).length > 0;


export const isTestTimeCompleted = test => test.completed;
export const isUserAttempted = test => test && test.pivot && test.pivot.test_status === 'attempted';
export const isUserUnAttempted = test => test && test.pivot && test.pivot.test_status === 'unattempted';
export const isUserSubmitted = test => test && test.pivot && test.pivot.test_status === 'submitted';

export const isTestCompleted = (test) => isTestTimeCompleted(test) || isUserSubmitted(test);
export const isUserPaid = test => test && test.pivot && test.pivot.payment_reference;

export const acceptedUserCount = test => test.accepted_user_count;
export const rejectedUserCount = test => test.rejected_user_count;

export const isSelfCreatedTest = test => test && test.pivot && test.pivot.mode_of_invite === 'owner';
export const isSharedTest = test => test && test.user_rank === 1 && test.pivot && test.pivot.mode_of_invite !== 'owner';
export const isUserRejected = test => test && test.pivot && test.pivot.response === 'reject';
export const isUserAcceptedSharedTest = test => !isSelfCreatedTest(test) && isUserPaid(test);

// export const isTestStarted = test
// export const isTestPaused;
export const isFixedTest  = schedule => schedule === 'fixed'
export const isAnyTimeTest = schedule => schedule === 'anytime'
export const isTimePeriodTest = schedule => schedule === 'timePeriod'
export const _isUserAttempted = userStatus => userStatus === 'attempted'
export const _isUserUnAttempted = userStatus => userStatus === 'unattempted'
export const _isUserSubmitted = userStatus => userStatus === 'submitted'
export const isTestInAnHour = startTime => ((moment(startTime) - moment()) / 1000 < 86400)
export const isTimeEndForTestStart = startTime => ((moment(startTime) - moment()) / 1000 < 0)
export const isTestSeriesFree = price =>  price < 1
export const isTestSeriesTestFree = isFree => isFree
export const isTestSeriesUserPaid = paymentId => paymentId
export const isPercentageArrayLengthZero = percentage => percentage && percentage.length === 0 







